<template>
    <step-wrapper class="
      flex size-full flex-col justify-between

      lg:!px-0 lg:pt-0
    ">
        <div class="lg:p-11 lg:pt-[64px]">
            <step-heading>
                {{ $t('REVIEW_DESIGN') }}
            </step-heading>
            <div>
                <template v-if="!haveGroupPersonalization">
                    <step-section-heading>
                        {{ $t('QUANTITY') }}
                    </step-section-heading>

                    <quantity-input
                        class="mb-[32px]"
                        :quantity="quantity"
                        @update-quantity="updateQuantity"
                    />
                </template>

                <step-section-heading>
                    {{ $t('SUMMARY') }}
                </step-section-heading>

                <order-summary />

                <div class="
                  my-[44px] flex justify-center gap-x-[24px]

                  lg:justify-start
                ">
                    <button
                        v-if="canShare"
                        class="
                          flex size-[48px] items-center justify-center rounded-full bg-gray-300 focus-outline-only

                          disabled:opacity-20
                        "
                        :aria-label="$t('SHARE')"
                        :disabled="!havePreview"
                        @click="sharePreview"
                    >
                        <share-icon class="text-gray-darkest" />
                    </button>

                    <button
                        class="
                          flex size-[48px] items-center justify-center rounded-full bg-gray-300 focus-outline-only

                          disabled:opacity-20
                        "
                        :aria-label="$t('DOWNLOAD')"
                        :disabled="!havePreview"
                        @click="downloadPreviewPng"
                    >
                        <file-download-icon class="text-gray-darkest" />
                    </button>

                    <button
                        class="flex size-[48px] items-center justify-center rounded-full bg-gray-300 focus-outline-only"
                        :aria-label="$t('HELP')"
                        @click="toggleHelpPanel"
                    >
                        <help-icon class="text-gray-darkest" />
                    </button>
                </div>
            </div>
        </div>
        <back-and-add-to-cart-mobile class="
          sticky bottom-0 hidden

          lg:block
        " />
    </step-wrapper>
</template>

<script>
    import FileSaver from 'file-saver';

    import allStores from '../../stores/all';
    import StepSectionHeading from '../UI/headings/StepSectionHeading.vue';
    import OrderSummary from '../OrderSummary.vue';
    import ShareIcon from '../icons/ShareIcon.vue';
    import FileDownloadIcon from '../icons/FileDownloadIcon.vue';
    import HelpIcon from '../icons/HelpIcon.vue';
    import StepWrapper from '../wrappers/StepWrapper.vue';
    import StepHeading from '../UI/headings/StepHeading.vue';
    import QuantityInput from '../UI/inputs/QuantityInput.vue';
    import BackAndAddToCartMobile from '../BackAndAddToCartMobile.vue';

    import {
        STEP_WALLET,
        STEP_REVIEW,
    } from '../../constants';

    export default {
        components: {
            StepSectionHeading,
            OrderSummary,
            ShareIcon,
            FileDownloadIcon,
            HelpIcon,
            StepWrapper,
            StepHeading,
            QuantityInput,
            BackAndAddToCartMobile,
        },

        mixins: [allStores],

        data() {
            return {
                STEP_REVIEW,

                quantity: 1,

                previewImages: null,
            };
        },

        computed: {
            groupPersonalization() {
                return this.customizerStore.groupPersonalization;
            },

            haveGroupPersonalization() {
                return this.groupPersonalization?.length > 0;
            },

            havePreview() {
                return this.previewImages != null;
            },

            canShare() {
                return window.navigator.share != null;
            },

            isHelpPanelOpen() {
                return this.customizerStore.isHelpPanelOpen;
            },
        },

        watch: {
            quantity() {
                this.customizerStore.setQuantity(this.quantity);
            },
        },

        mounted() {
            this.quantity = this.customizerStore.quantity;

            this.savePreview();
        },

        methods: {
            addToCart() {
                this.customizerStore.saveRecipe();
            },

            backToCustomizer() {
                this.appStore.setCurrentStep(STEP_WALLET);
            },

            updateQuantity(newQuantity) {
                const v = parseInt(newQuantity, 10);

                this.quantity = Number.isNaN(v) ? 1 : v;
            },

            toggleHelpPanel() {
                this.customizerStore.toggleHelpPanel();
            },

            savePreview() {
                this.customizerStore.getPreviewImages().then((result) => {
                    this.previewImages = result;
                });
            },

            async sharePreview() {
                const images = this.previewImages;

                if (window.navigator.share) {
                    fetch(images.previewPng).then((response) => response.blob()).then((image) => {
                        const fileName = 'ridge-preview.png';

                        const data = {
                            files: [
                                new File([image], fileName, {
                                    type: image.type,
                                }),
                            ],
                            title: 'Preview',
                        };

                        window.navigator.share(data);
                    });
                }
            },

            async downloadPreviewPng() {
                const images = this.previewImages;

                const { previewPng } = images;

                FileSaver.saveAs(previewPng, 'preview.png');
            },
        },
    };
</script>
